// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./app_controller.js";
application.register("app", HelloController);

import ModalController from "./modal_controller.js";
application.register("modal", ModalController);

import OnchangeFormController from "./onchange_form_controller.js";
application.register("onchange-form", OnchangeFormController);

import SearchFiltersController from "./search_filters_controller.js";
application.register("search-filters", SearchFiltersController);

import NumberFormatController from "./number_format_controller.js";
application.register("number-format", NumberFormatController);

import DynamicSelectController from "./dynamic_select_controller.js";
application.register("dynamic-select", DynamicSelectController);

import TooltipController from "./tooltip_controller.js";
application.register("tooltip", TooltipController);

import AsyncSaveController from "./async_save_controller.js";
application.register("async-save", AsyncSaveController);

import DropzoneController from "./dropzone_controller.js";
application.register("dropzone", DropzoneController);

import TsSelectController from "./ts_select_controller.js";
application.register("ts-select", TsSelectController);

import TsSelectRemoteController from "./ts_select_remote_controller.js";
application.register("ts-select-remote", TsSelectRemoteController);

import TsSelectCreateController from "./ts_select_create_controller.js";
application.register("ts-select-create", TsSelectCreateController);

import TsSelectRemoveController from "./ts_select_remove_controller.js";
application.register("ts-select-remove", TsSelectRemoveController);

import TsSelectCreateRemoveController from "./ts_select_create_remove_controller.js";
application.register("ts-select-create-remove", TsSelectCreateRemoveController);

import FlatpickrController from "./flatpickr_controller.js";
application.register("flatpickr", FlatpickrController);

import FlatpickrTimeController from "./flatpickr_time_controller.js";
application.register("flatpickr_time", FlatpickrTimeController);

import FlatpickrFormattedController from "./flatpickr_formatted_controller.js";
application.register("flatpickr-formatted", FlatpickrFormattedController);

import FlatpickrFormattedDatetimeController from "./flatpickr_formatted_datetime_controller.js";
application.register(
  "flatpickr-formatted-datetime",
  FlatpickrFormattedDatetimeController,
);

import PerPageController from "./per_page_controller";
application.register("per-page", PerPageController);

import RichTextController from "./rich_text_editor_controller";
application.register("rich-text-editor", RichTextController);

import Sortable from "stimulus-notification";
application.register("notification", Sortable);

import Notification from "stimulus-sortable";
application.register("sortable", Notification);

import CheckboxSelectAll from "stimulus-checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll);

import NestedForm from "stimulus-rails-nested-form";
application.register("nested-form", NestedForm);

import RailsAutosave from "stimulus-rails-autosave";
application.register("autosave", RailsAutosave);

import CustomNestedForm from "./custom_nested_form_controller";
application.register("custom-nested-form", CustomNestedForm);

// import Clipboard from "./clipboard_controller";
// application.register("clipboard", Clipboard);

import Search from "./search_controller";
application.register("search", Search);
import SearchResults from "./search_results_controller";
application.register("search-results", SearchResults);

import Lightbox from "stimulus-lightbox";
application.register("lightbox", Lightbox);

import SelectAllSublist from "./select_all_sublist_controller";
application.register("select-all-sublist", SelectAllSublist);

import Clipboard from "@stimulus-components/clipboard";
application.register("clipboard", Clipboard);

import Sidebar from "./sidebar_controller";
application.register("sidebar", Sidebar);

import ImportLoading from "./import_loading_controller";
application.register("import-loading", ImportLoading);

import MagazzinoGriglia from "./magazzino_griglia_controller";
application.register("magazzino-griglia", MagazzinoGriglia);
